import React from 'react'
import { useTrans } from '@next-nx/hooks'
import { WContainer, Breadcrumbs, MainTitle, WImage, Tag, Button } from '@next-nx/shared-ui/atoms'
import { NewsSection, Page } from '@next-nx/shared-ui/organisms'
import styles from './MagazineTemplate.module.sass'
import { NewsType } from '@next-nx/utils/types'
import Download from '../../atoms/Icons/Download'
import { ArticleJsonLd } from 'next-seo'
import { DOMAIN, LOGO_URL } from '@next-nx/utils/settings'


interface Props {
  news: NewsType
  pagina: any
}


function MagazineTemplate(props: Props) {
  const {
    news,
    pagina = {},
  } = props

  const t = useTrans()

  let magazineImages = []
  if ( news?.immagine )
    magazineImages.push(news?.immagine)

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <WContainer>
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} className={styles.breadcrumbs} />
        <MainTitle label={news?.titolo} className={styles.maintitle} />

        <div className={styles.container}>

          <p>{pagina?.descrizione}</p>

          <div className={styles.image}>
            <WImage src={news?.immagine} alt={news?.titolo} title={news?.titolo} maxWidth={730} maxHeight={300} objectFit={'contain'} layout={'intrinsic'} />
          </div>
          
          <div className={styles?.intestazione}>
            <div className={styles?.tags}>
              {news?.tags.map(tag => (
                <div className={styles.ButtonSm} key={tag.pk}>
                  <Tag label={tag.nome} color={'blue'} />
                </div>
              ))}
            </div>
            {!!news?.dataPubblicazione && <div className={styles.dataPubblicazione} ><p>{news.dataPubblicazione}</p></div>}
          </div>
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: news?.descrizione }} />
          {!!news?.allegato && <div className={styles.allegato}><Button newPage={true} label={t("Scarica il documento")} size={'sm'} iconPos={'left'} icon={<Download />} color={'default'} href={news.allegato} variant={'ghost'} /></div>}
        </div>
      </WContainer>

      {!!news?.newsCorrelate && <div className={styles.correlatiBox}>
        <NewsSection
            variant="variant2"
            news={news.newsCorrelate}
            titolo={t('Potrebbero interessarti anche')}
            ctaLabel={t("Torna all'elenco")}
            url={'/magazine'}
          />
      </div>}
      <ArticleJsonLd
        url={DOMAIN + news?.url}
        title={news?.titolo ? news?.titolo : ''}
        images={magazineImages}
        datePublished={news?.dataPubblicazione}
        authorName={['Unipolrental']}
        publisherName="Unipolrental"
        publisherLogo={LOGO_URL}
        description={news?.descrizione ? news?.descrizione.replace(/<\/?[^>]+(>|$)/gi, "").replace(/\&nbsp;/g, ' ').substring(0, 300) + "..." : ''} />
    </Page>
  )
}

export default MagazineTemplate
